import React from 'react';

import classNames from 'classnames';

import { money } from './planHelpers';

/**
 * IB-701 — the four Approvals summary cards. A dark charcoal "Awaiting approval" hero (which
 * deliberately EXCLUDES direct commitments) sits alongside three white cards: PRs and EAs each
 * show their combined value plus how many are pending, and DCs shows a headline count. Figures
 * come from the procurements.data.approvals-summary aggregate.
 *
 * Card tokens (tw-rounded-lg tw-bg-white tw-shadow-primary + charcoal hero) match the Overview
 * KPI cards; colours come from tailwind.config.js.
 */
const SummaryCard = ({ label, value, subtitle }) => (
    <div className="tw-flex tw-flex-col tw-gap-2 tw-rounded-lg tw-bg-white tw-shadow-primary tw-px-5 tw-py-4">
        <div className="tw-text-sm tw-font-medium tw-text-charcoal-75">{label}</div>
        <div className="tw-text-2.5xl tw-font-semibold tw-leading-none tw-text-charcoal">{value}</div>
        {subtitle && <div className="tw-text-xs tw-text-charcoal-50">{subtitle}</div>}
    </div>
);

const ApprovalsSummaryCards = ({ summary, currencySymbol, loading }) => {
    const awaitingValue = summary?.awaiting_approval_value ?? 0;
    const awaitingCount = summary?.awaiting_approval_count ?? 0;
    const prTotal = summary?.pr_total ?? 0;
    const prPending = summary?.pr_pending_count ?? 0;
    const eaTotal = summary?.ea_total ?? 0;
    const eaPending = summary?.ea_pending_count ?? 0;
    const dcCount = summary?.dc_count ?? 0;

    return (
        <div className={classNames('tw-grid tw-grid-cols-1 sm:tw-grid-cols-2 lg:tw-grid-cols-4 tw-gap-3', { 'tw-opacity-60': loading })}>
            <div className="tw-flex tw-flex-col tw-gap-2 tw-rounded-lg tw-bg-charcoal tw-text-white tw-px-5 tw-py-4">
                <div className="tw-text-sm tw-font-medium tw-text-white tw-opacity-80">{$t('Awaiting approval')}</div>
                <div className="tw-text-2.5xl tw-font-semibold tw-leading-none tw-text-white">{money(currencySymbol, awaitingValue)}</div>
                <div className="tw-text-xs tw-text-white tw-opacity-80">{$t('{{count}} items pending sign-off', { count: awaitingCount })}</div>
            </div>

            <SummaryCard label={$t('PRs')} value={money(currencySymbol, prTotal)} subtitle={$t('{{count}} pending', { count: prPending })} />
            <SummaryCard label={$t('EAs')} value={money(currencySymbol, eaTotal)} subtitle={$t('{{count}} pending', { count: eaPending })} />
            <SummaryCard label={$t('DCs')} value={dcCount} subtitle={$t('direct commitments')} />
        </div>
    );
};

export default ApprovalsSummaryCards;
